import React, { useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import {
  IoPerson,
  IoHome,
  IoLogOut,
  IoBusiness,
  IoLeaf,
  IoAirplane,
  IoCreate,
  IoBagHandle,
  IoCaretDown,
  IoCaretUp,
} from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { LogOut, reset } from "../features/authSlice";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./sidebar.css";
import logo from "../logo.png";

const Sidebar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const location = useLocation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const logout = () => {
    dispatch(LogOut());
    dispatch(reset());
    navigate("/login");
  };

  const userRole = user ? user.role : null;

  return (
    <div>
      <aside className="menu pl-2 has-shadow" id="sidebar">
        <div className="col text-center">
          <img
            src={logo}
            alt="Cassava Super Logo"
            style={{ width: "30%" }}
            className="logo-sidebar"
          />
        </div>
        <div className="sidebar-logo text-center pt-2">
          <h3>
            <strong>Cassava Super</strong>
          </h3>
        </div>

        <p className="menu-label">General</p>
        <ul className="menu-list">
          <li>
            <NavLink to={"/dashboard"}>
              <IoHome /> Dashboard
            </NavLink>
          </li>

          {(userRole === "petani" || userRole === "perusahaan") && (
            <li className="mt-3">
              <NavLink to={"/rencanatanam"}>
                <IoCreate /> Rencana Tanam
              </NavLink>
            </li>
          )}

          <li className="mt-3">
            <NavLink to={"/order"}>
              <IoBagHandle /> Order Panen
            </NavLink>
          </li>
        </ul>

        {userRole === "admin" && (
          <div>
            <p className="menu-label">Users</p>
            <ul className="menu-list">
              <li>
                <NavLink to={"/users"}>
                  <IoPerson /> Users
                </NavLink>
              </li>
            </ul>
          </div>
        )}

        {userRole && userRole !== "admin" && (
          <div>
            <p className="menu-label">Profile</p>
            {userRole === "perusahaan" && (
              <ul className="menu-list">
                <li>
                  <NavLink to={"/profile-perusahaan"}>
                    <IoPerson /> Profile Perusahaan
                  </NavLink>
                </li>
              </ul>
            )}
            {userRole === "petani" && (
              <ul className="menu-list">
                <li>
                  <NavLink to={"/profile-petani"}>
                    <IoPerson /> Profile Petani
                  </NavLink>
                </li>
              </ul>
            )}
            {userRole === "pabrik" && (
              <ul className="menu-list">
                <li>
                  <NavLink to={"/profile-pabrik"}>
                    <IoPerson /> Profile Pabrik
                  </NavLink>
                </li>
              </ul>
            )}
            {userRole === "logistik" && (
              <ul className="menu-list">
                <li>
                  <NavLink to={"/profile-logistik"}>
                    <IoPerson /> Profile Logistik
                  </NavLink>
                </li>
              </ul>
            )}
          </div>
        )}

        <div>
          <p className="menu-label">Data-data</p>
          {(userRole === "admin" ||
            userRole === "perusahaan" ||
            userRole === "petani") && (
            <ul className="menu-list">
              <li>
                <NavLink to={"/datalahan"}>
                  <IoLeaf /> Data Petani
                </NavLink>
              </li>
            </ul>
          )}
          {(userRole === "admin" ||
            userRole === "perusahaan" ||
            userRole === "pabrik") && (
            <ul className="menu-list">
              <li>
                <div
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    color: "#333",
                    marginBottom: "5px"
                  }}
                >
                  <IoBusiness />
                  <span style={{ marginLeft: "5px" }}>Data Pabrik</span>
                  {isDropdownOpen ? (
                    <IoCaretUp style={{ marginLeft: "auto" }} />
                  ) : (
                    <IoCaretDown style={{ marginLeft: "auto" }} />
                  )}
                </div>
                <ul
                  className={`menu-list submenu ${
                    isDropdownOpen ? "open" : "closed"
                  }`}
                >
                  <li className="mb-1">
                    <NavLink className="submenu-item" to="/data-pabrik">
                      Data Dasar
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="submenu-item" to="/produksi">
                      Data Produksi
                    </NavLink>
                  </li>
                </ul>
              </li>
            </ul>
          )}

          {(userRole === "admin" ||
            userRole === "perusahaan" ||
            userRole === "logistik") && (
            <ul className="menu-list">
              <li>
                <NavLink to={"/data-logistik"}>
                  <IoAirplane /> Data Logistik
                </NavLink>
              </li>
            </ul>
          )}
        </div>

        <ul className="button text-center">
          <li>
            <button onClick={logout} className="btn btn-danger">
              <IoLogOut /> Logout
            </button>
          </li>
        </ul>
      </aside>
    </div>
  );
};

export default Sidebar;
